export const normalizeQuantityValue = (quantity) => {
	if (typeof quantity === "number") {
		return Number.isFinite(quantity) ? quantity : 0;
	}
	if (typeof quantity === "string") {
		const normalizedText = quantity.includes(",") ? quantity.replace(/\./g, "").replace(",", ".") : quantity;
		const parsedQuantity = Number(normalizedText);
		return Number.isFinite(parsedQuantity) ? parsedQuantity : 0;
	}
	return 0;
};

export const isUnitMeasurement = (unitMeasurement) => unitMeasurement === "u" || unitMeasurement === "1";
export const getManualCodeSlotCount = (line, extraSlots = 0) => {
	const pendingQuantity = normalizeQuantityValue(line.pending_quantity);
	if (pendingQuantity <= 0) {
		return 0;
	}

	if (isUnitMeasurement(line.unit_measurement)) {
		return Math.ceil(pendingQuantity);
	}

	return Math.max(1, extraSlots);
};

export const buildManualCodeSlots = (line, manualCodes = [], extraSlots = 0) => {
	const slotCount = getManualCodeSlotCount(line, extraSlots);
	return Array.from({ length: slotCount }, (_, index) => manualCodes[index] || "");
};

export const getFilledManualCodes = (manualCodes) => manualCodes.map((code) => code.trim()).filter(Boolean);
